import React, { useEffect, useState, useRef } from 'react';
interface LazySectionProps {
  children: React.ReactNode;
  className?: string;
  /** Height placeholder before content loads (prevents layout shift) */
  minHeight?: string;
  /** How far before the section enters the viewport to start rendering (px) */
  rootMargin?: string;
}
export function LazySection({
  children,
  className = '',
  minHeight = '200px',
  rootMargin = '200px'
}: LazySectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    // If IntersectionObserver isn't supported, render immediately
    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [rootMargin]);
  return <div ref={ref} className={className} style={!isVisible ? {
    minHeight
  } : undefined} data-id="element-1403">
      {isVisible ? children : null}
    </div>;
}